module.exports = __webpack_public_path__ + "img/iphone-frame.2c52b1f4.png";